export enum LocalStorageKeys {
  VideoCallData = 'video_call_data',
  UserData = 'user_data',
  GlpData = 'glp_data',
  UtmParams = 'utm_params'
}
